export const PORTFOLIO_CATEGORY = 'EI';
export const PORTFOLIO_PERFORMANCE_CATEGORY = 'EPI';
export const PORTFOLIO_INVENTORY_CATEGORY = 'EII';
export const SITE_LIST_SUM_NODE = 'sum';
export const PORTFOLIO_SUM_NODE = 'summary';

export const startInPage = [
  { key: 'siteSummary', value: 'Site_Summary' },
  { key: 'todoList', value: 'To-do_list' },
  { key: 'liveConnect', value: 'Live_Connect' },
  { key: 'tempConsump', value: 'Temperature_and_consumption_view' },
];
export const initialStartIn = 'todoList';

export const dataView = {
  todoList: 'pai',
  siteSummary: 'ais',
  tempConsump: 'tempConsump',
  liveConnect: 'liveConnect',
};

export const INVENTORY_INSIGHTS_LABEL = 'Inventory_Insights';

export const sidebarListId = { siteSummary: 'siteSummary' };
